export default {
  notificationsData: (state) => state.appNotifications.items
}
